module.exports = __webpack_public_path__ + "img/3x2.9324e30c.png";